// if arr contains object, count the object with the same prop as duplicates
const removeDuplicate = (arr, prop) => {
  const propArr = arr.map((item) => item[prop]);
  return arr.filter((item, index) => {
    return propArr.indexOf(item[prop]) === index;
  });
};

// arr is an array full of objects with timeProp
// this function return array sorted from newest to oldest
const sortByTime = (arr, timeProp) => {
  return arr.sort((a, b) => new Date(b[timeProp]) - new Date(a[timeProp]));
};

export { removeDuplicate, sortByTime };
